/* eslint-disable */
import axios from 'axios'
import config from '@/config'
import {axiosWrapper} from '@/shared/api.utils'


let usersModule = {
  namespaced: true,
  state: {
    superUsers: null,
  },
  mutations: {
    updateUsers (state, payload) {
      state.superUsers = payload
    },
    updateSuperUserLoginMutation (state, payload) {
      let user = _.find(state.superUsers, superUser => {
          return superUser.id === payload.user_id;
        });
      if (!!user) {
        user.superuser_login = payload.superuser_login
      }
    }
  },
  actions: {
    loadSuperUsers (context, payload) {
      console.log('Loading superusers...')
      return new Promise((resolve, reject) => {
        let data = {
          token: localStorage.carrierToken
        }
        axios.get(`${config.url}/portal-users/`, data)
        .then((response) => {
          // success
          context.commit('updateUsers', response.data)
          resolve(response)
        }, (e) => {
          console.log(e)
          reject(e)
          return false
        })
        .catch((e) => {
          console.log(e)
          reject(e)
          return false
        })
      })
    },
    deleteSuperUser (context, payload) {
      return new Promise((resolve, reject) => {
        let data = {
          token: localStorage.carrierToken
        }
        let promise = axios.delete(`${config.url}/portal-users/${payload.userId}/`, data)
        promise.then((response) => {
          if (response.data.success) {
            resolve(response)
          }
        }, (e) => {
          reject(e)
          return false
        })
          .catch((e) => {
            reject(e)
            return false
          })
      })
    },
    async addSuperUser (context, payload) {
      console.log('Add superUser...')
      return await axiosWrapper(axios.post(`${config.url}/portal-users/`, payload))
    },
    resetSuperUserPassword (context, payload) {
      return new Promise((resolve, reject) => {
        let data = {
          new_password: payload.password,
          token: localStorage.carrierToken
        }
        let promise = axios.post(`${config.url}/portal-users/${payload.userId}/reset-password`, data)
        promise.then((response) => {
          if (response.data.success) {
            console.log('response.data: ', response)
            resolve(response)
          }
        }, (e) => {
          reject(e)
          return false
        })
          .catch((e) => {
            console.log(e)
            reject(e)
            return false
          })
      })
    },
    updateSuperUserLogin (context, payload) {
      return new Promise((resolve, reject) => {
        let data = {
          superuser_login: payload.superuser_login,
          token: localStorage.carrierToken
        }
        let promise = axios.post(`${config.url}/portal-users/${payload.userId}/update_superuser_login`, data)
        promise.then((response) => {
          if (response.data.success) {
            console.log('response.data: ', response)
            context.commit('updateSuperUserLoginMutation',
                {user_id: payload.userId, superuser_login: payload.superuser_login})
            resolve(response)
          }
        }, (e) => {
          reject(e)
          return false
        })
          .catch((e) => {
            console.log(e)
            reject(e)
            return false
          })
      })
    }
  },
  getters: {

  }
}

export default usersModule